import { Button, Center, Input, VStack, Text, Link } from "native-base";
import { ImageBackground, StyleSheet, Image } from "react-native";
import { useNavigation } from '@react-navigation/native';


type AuthScreenProps = {
  handleSignIn: (navigation: any) => void;
  error: string | null;
  setEmail: (text: string) => void;
  setPassword: (text: string) => void;
  myEmail: string;
  password: string;
};

function AuthScreen({
                      handleSignIn,
                      error,
                      setEmail,
                      setPassword,
                      myEmail,
                      password,
                    }: AuthScreenProps) {
  const navigation = useNavigation();



  
  return (
    <ImageBackground
      source={{ uri: 'https://taentregue.com.br/imagem/fundo.png' }}
      style={styles.background}
      resizeMode="cover"
    >
      <Center flex={1} p={4}>
        <Text
          color="#384085"
          lineHeight="27.23px"
          fontWeight="700"
          marginBottom="20px"
          fontSize="17px"
        >
          Faça seu login
        </Text>
        <VStack space={4} width="80%">
          <Input
            borderRadius="25px"
            borderColor="#384085"
            height="50px"
            placeholder="Número de celular ou email"
            value={myEmail}
            onChangeText={setEmail}
            variant="outline"
            paddingLeft="15px"
          />
          <Input
            borderRadius="25px"
            borderColor="#384085"
            height="50px"
            placeholder="Senha"
            value={password}
            onChangeText={setPassword}
            type="password"
            variant="outline"
            paddingLeft="15px"
          />
          {error && <Text color="red.500">{error}</Text>}
          <Center>
            <Button
              borderRadius="25px"
              background="#384085"
              width="144px"
              height="50px"
              onPress={() => handleSignIn(navigation)}
              _text={{ color: "#fff", fontWeight: "500", fontSize: "16px" }}
            >
              Entrar
            </Button>
          </Center>
        </VStack>
  
        <Image
            source={{ uri: 'https://taentregue.com.br/imagem/logo.png' }}
          style={styles.logo}
          resizeMode="contain"
        />
      </Center>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  background: {
    flex: 1,
    width: "100%", 
    height: "100%", 
  },
  logo: {
    position: "absolute",
    bottom: 30, 
    alignSelf: "center",
    width: 150,
    height: 50,
  },
});

export default AuthScreen;
